import * as yup from 'yup'

export const schema = yup.object({
  allowedIdleFlow: yup
    .number()
    .typeError('Allowed Idle Flow must be a number')
    .min(0, 'Allowed Idle Flow cannot be negative')
    .required('Allowed Idle Flow is required'),
  maxLowDeviation: yup
    .number()
    .typeError('Max Low Deviation must be a number')
    .integer('Max Low Deviation must be an integer')
    .min(0, 'Max Low Deviation cannot be negative')
    .max(255, 'Max Low Deviation must be less than 256')
    .required('Max Low Deviation is required'),
  maxHighDeviation: yup
    .number()
    .typeError('Max High Deviation must be a number')
    .integer('Max High Deviation must be an integer')
    .min(0, 'Max High Deviation cannot be negative')
    .max(255, 'Max High Deviation must be less than 256')
    .required('Max High Deviation is required'),
  startDelay: yup
    .number()
    .typeError('Start Delay must be a number')
    .integer('Start Delay must be an integer')
    .min(0, 'Start Delay cannot be negative')
    .max(34464, 'Start Delay must be less than 34464')
    .required('Start Delay is required'),
  changeDelay: yup
    .number()
    .typeError('Change Delay must be a number')
    .integer('Change Delay must be an integer')
    .min(0, 'Change Delay cannot be negative')
    .max(34464, 'Change Delay must be less than 34464')
    .required('Change Delay is required'),
  errorDelay: yup
    .number()
    .typeError('Error Delay must be a number')
    .integer('Error Delay must be an integer')
    .min(0, 'Error Delay cannot be negative')
    .max(34464, 'Error Delay must be less than 34464')
    .required('Error Delay is required'),
  stableDeviation: yup
    .number()
    .typeError('Stable Deviation must be a number')
    .integer('Stable Deviation must be an integer')
    .min(0, 'Stable Deviation cannot be negative')
    .max(255, 'Stable Deviation must be less than 256')
    .required('Stable Deviation is required'),
  stableCount: yup
    .number()
    .typeError('Stable Count must be a number')
    .integer('Stable Count must be an integer')
    .min(0, 'Stable Count cannot be negative')
    .max(100, 'Stable Count must be less than or equal to 100')
    .required('Stable Count is required'),
  stableMax: yup
    .number()
    .typeError('Stable Max be a number')
    .integer('Stable Max must be an integer')
    .min(0, 'Stable Max cannot be negative')
    .max(30, 'Stable Max must be less than or equal to 30')
    .required('Stable Max is required'),
})
